function resultQuestions(formQuestions, formAnswers) {
  let sumPoints = 0
  let total = 0
  for (let i = 0; i < formQuestions.length; i += 1) {
    const question = formQuestions[i]
    const key = question.field
    sumPoints += (formAnswers[key] * question.weight)
    total += 100 * question.weight
  }
  return Math.floor(sumPoints / total * 100)
}

const questionsVuex = {
  data() {
    return {
      confirmEmail: this.$store.state.diagnosis.email,
      form: { ...this.$store.state[this.keyForm] },
      userid: this.$store.state.userid,
      usercode: this.$store.state.usercode,
      questions: this.$store.state.questions[this.keyForm],
    }
  },
  methods: {
    rangeChange(newValue, id) {
      this.form[id] = newValue
      this.$store.commit('UPDATE_FIELD', {
        form: this.keyForm,
        key: id,
        value: newValue
      })
    }
  },
  beforeDestroy() {
    this.$store.commit('UPDATE_FIELD', {
      form: 'test_results',
      key: `${this.keyForm}`,
      value: resultQuestions(this.questions, this.form)
    })

    const data = {
      cultura_e_lideranca: this.$store.state.cultura_e_lideranca,
      experiencia_do_cliente: this.$store.state.experiencia_do_cliente,
      empreendedorismo_digital: this.$store.state.empreendedorismo_digital,
      tecnologia_digital: this.$store.state.tecnologia_digital,
      agilidade_operacional: this.$store.state.agilidade_operacional,
      test_results: this.$store.state.test_results
    }

    try {
      this.$http.post('/api/user/' + this.userid + '/' + this.usercode, data);
    } catch (e) {}
  }
}

export default questionsVuex;



// WEBPACK FOOTER //
// ./src/components/mixins/questionsVuexTeste.js